import type { SVGProps } from 'react';

const SvgMoneyCreditCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 5H6C4.35 5 3 6.35 3 8v8c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3V8c0-1.65-1.35-3-3-3M6 7h12c.55 0 1 .45 1 1v1H5V8c0-.55.45-1 1-1m12 10H6c-.55 0-1-.45-1-1v-5h14v5c0 .55-.45 1-1 1"
    />
    <path
      fill="currentcolor"
      d="M9 13H8c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1m5 0h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgMoneyCreditCard;
